function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 106,
  height: 106,
  fill: "#222222",
  fillOpacity: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M32.104 58H33.196V51.484H32.104V58ZM32.656 50.14C33.088 50.14 33.388 49.852 33.388 49.408C33.388 48.988 33.088 48.7 32.656 48.7C32.224 48.7 31.924 48.988 31.924 49.408C31.924 49.852 32.224 50.14 32.656 50.14Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.4086 58H36.5006V53.272C37.1006 52.6 37.6526 52.276 38.1446 52.276C38.9726 52.276 39.3566 52.792 39.3566 54.016V58H40.4486V53.272C41.0606 52.6 41.5886 52.276 42.0926 52.276C42.9206 52.276 43.3046 52.792 43.3046 54.016V58H44.3966V53.872C44.3966 52.204 43.7606 51.316 42.4166 51.316C41.6246 51.316 40.9406 51.832 40.2686 52.564C40.0046 51.796 39.4646 51.316 38.4686 51.316C37.6886 51.316 37.0046 51.808 36.4406 52.432H36.4046L36.3086 51.484H35.4086V58Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M48.018 58.156C48.822 58.156 49.554 57.736 50.178 57.22H50.214L50.31 58H51.21V53.992C51.21 52.384 50.538 51.316 48.954 51.316C47.91 51.316 46.986 51.784 46.386 52.168L46.818 52.924C47.334 52.576 48.018 52.228 48.774 52.228C49.842 52.228 50.118 53.032 50.118 53.872C47.346 54.184 46.11 54.892 46.11 56.308C46.11 57.484 46.926 58.156 48.018 58.156ZM48.33 57.28C47.682 57.28 47.178 56.98 47.178 56.236C47.178 55.396 47.922 54.856 50.118 54.592V56.416C49.482 56.98 48.966 57.28 48.33 57.28Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M55.4874 61C57.5034 61 58.7875 59.956 58.7875 58.744C58.7875 57.676 58.0195 57.196 56.5075 57.196H55.2355C54.3595 57.196 54.0955 56.908 54.0955 56.488C54.0955 56.128 54.2754 55.912 54.5154 55.708C54.8034 55.852 55.1634 55.936 55.4874 55.936C56.8074 55.936 57.8635 55.06 57.8635 53.668C57.8635 53.104 57.6475 52.624 57.3355 52.324H58.6674V51.484H56.3995C56.1715 51.4 55.8474 51.316 55.4874 51.316C54.1674 51.316 53.0394 52.216 53.0394 53.644C53.0394 54.424 53.4595 55.048 53.8915 55.396V55.444C53.5555 55.684 53.1595 56.116 53.1595 56.656C53.1595 57.172 53.4115 57.52 53.7595 57.724V57.772C53.1475 58.168 52.7994 58.696 52.7994 59.248C52.7994 60.376 53.8914 61 55.4874 61ZM55.4874 55.192C54.7314 55.192 54.0955 54.592 54.0955 53.644C54.0955 52.684 54.7194 52.12 55.4874 52.12C56.2554 52.12 56.8795 52.696 56.8795 53.644C56.8795 54.592 56.2314 55.192 55.4874 55.192ZM55.6434 60.256C54.4674 60.256 53.7595 59.8 53.7595 59.104C53.7595 58.72 53.9515 58.336 54.4195 58C54.7075 58.072 55.0195 58.108 55.2595 58.108H56.3875C57.2515 58.108 57.7194 58.312 57.7194 58.912C57.7194 59.596 56.8914 60.256 55.6434 60.256Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M62.5054 58.156C63.3934 58.156 64.0894 57.856 64.6654 57.484L64.2694 56.764C63.7894 57.088 63.2734 57.28 62.6374 57.28C61.4014 57.28 60.5494 56.392 60.4774 55H64.8694C64.8934 54.844 64.9174 54.616 64.9174 54.376C64.9174 52.516 63.9814 51.316 62.3254 51.316C60.8134 51.316 59.3854 52.636 59.3854 54.748C59.3854 56.896 60.7774 58.156 62.5054 58.156ZM60.4654 54.208C60.5974 52.936 61.4134 52.192 62.3374 52.192C63.3574 52.192 63.9574 52.9 63.9574 54.208H60.4654Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M66.4739 58H71.2979V57.088H69.5339V49.444H68.6939C68.2139 49.732 67.6499 49.936 66.8699 50.068V50.776H68.4299V57.088H66.4739V58Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M106 0V106",
  stroke: "#222222",
  strokeOpacity: 0.2,
  strokeDasharray: "3 3"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 106,
  width: 249,
  height: 106,
  fill: "#222222",
  fillOpacity: 0.2
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M209.567 58H210.659V51.484H209.567V58ZM210.119 50.14C210.551 50.14 210.851 49.852 210.851 49.408C210.851 48.988 210.551 48.7 210.119 48.7C209.687 48.7 209.387 48.988 209.387 49.408C209.387 49.852 209.687 50.14 210.119 50.14Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M212.872 58H213.964V53.272C214.564 52.6 215.116 52.276 215.608 52.276C216.436 52.276 216.82 52.792 216.82 54.016V58H217.912V53.272C218.524 52.6 219.052 52.276 219.556 52.276C220.384 52.276 220.768 52.792 220.768 54.016V58H221.86V53.872C221.86 52.204 221.224 51.316 219.88 51.316C219.088 51.316 218.404 51.832 217.732 52.564C217.468 51.796 216.928 51.316 215.932 51.316C215.152 51.316 214.468 51.808 213.904 52.432H213.868L213.772 51.484H212.872V58Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M225.481 58.156C226.285 58.156 227.017 57.736 227.641 57.22H227.677L227.773 58H228.673V53.992C228.673 52.384 228.001 51.316 226.417 51.316C225.373 51.316 224.449 51.784 223.849 52.168L224.281 52.924C224.797 52.576 225.481 52.228 226.237 52.228C227.305 52.228 227.581 53.032 227.581 53.872C224.809 54.184 223.573 54.892 223.573 56.308C223.573 57.484 224.389 58.156 225.481 58.156ZM225.793 57.28C225.145 57.28 224.641 56.98 224.641 56.236C224.641 55.396 225.385 54.856 227.581 54.592V56.416C226.945 56.98 226.429 57.28 225.793 57.28Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M232.95 61C234.966 61 236.25 59.956 236.25 58.744C236.25 57.676 235.482 57.196 233.97 57.196H232.698C231.822 57.196 231.558 56.908 231.558 56.488C231.558 56.128 231.738 55.912 231.978 55.708C232.266 55.852 232.626 55.936 232.95 55.936C234.27 55.936 235.326 55.06 235.326 53.668C235.326 53.104 235.11 52.624 234.798 52.324H236.13V51.484H233.862C233.634 51.4 233.31 51.316 232.95 51.316C231.63 51.316 230.502 52.216 230.502 53.644C230.502 54.424 230.922 55.048 231.354 55.396V55.444C231.018 55.684 230.622 56.116 230.622 56.656C230.622 57.172 230.874 57.52 231.222 57.724V57.772C230.61 58.168 230.262 58.696 230.262 59.248C230.262 60.376 231.354 61 232.95 61ZM232.95 55.192C232.194 55.192 231.558 54.592 231.558 53.644C231.558 52.684 232.182 52.12 232.95 52.12C233.718 52.12 234.342 52.696 234.342 53.644C234.342 54.592 233.694 55.192 232.95 55.192ZM233.106 60.256C231.93 60.256 231.222 59.8 231.222 59.104C231.222 58.72 231.414 58.336 231.882 58C232.17 58.072 232.482 58.108 232.722 58.108H233.85C234.714 58.108 235.182 58.312 235.182 58.912C235.182 59.596 234.354 60.256 233.106 60.256Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M239.968 58.156C240.856 58.156 241.552 57.856 242.128 57.484L241.732 56.764C241.252 57.088 240.736 57.28 240.1 57.28C238.864 57.28 238.012 56.392 237.94 55H242.332C242.356 54.844 242.38 54.616 242.38 54.376C242.38 52.516 241.444 51.316 239.788 51.316C238.276 51.316 236.848 52.636 236.848 54.748C236.848 56.896 238.24 58.156 239.968 58.156ZM237.928 54.208C238.06 52.936 238.876 52.192 239.8 52.192C240.82 52.192 241.42 52.9 241.42 54.208H237.928Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M243.409 58H248.941V57.052H246.457C246.001 57.052 245.473 57.1 245.017 57.136C247.045 55 248.509 53.404 248.509 51.796C248.509 50.284 247.525 49.288 245.953 49.288C244.837 49.288 244.081 49.804 243.361 50.584L243.997 51.196C244.477 50.632 245.101 50.176 245.821 50.176C246.913 50.176 247.441 50.872 247.441 51.844C247.441 53.248 245.989 54.784 243.409 57.352V58Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var SvgTemplate5Grey = function SvgTemplate5Grey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 106,
    viewBox: "0 0 355 106",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTemplate5Grey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/template5_grey.8791e182.svg";
export { ForwardRef as ReactComponent };